import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ControllerService } from '../shared/services/controller.service';
import { ActivatedRoute, Params } from '@angular/router';
import { HttpService } from '../shared/services/http.service';

const DEFAULT_REQUIRED_TEXT = 'Required.';
@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit {

  @ViewChild ('textEntry', { static: false }) textEntry: any

  pageObserver: Subscription
  page: number
  totalSteps: number
  optional: boolean = false
  hidePageNumbers: boolean = false
  pageComponent: null
  saveToUser = ''

  requiredText = DEFAULT_REQUIRED_TEXT
  displayRequired = false

  textElements = []
  otherElements = []

  dropdownOptions = []

  pages: any = []
  elements: any = []

  value: any = null

  responses: {
    question: string,
    answer: string
  }[] = []

  question: string = ''

  constructor(public controller: ControllerService, private route: ActivatedRoute, private http: HttpService) { }

  async ngOnInit() {

    this.pages = this.controller.getSectionComponents().filter( ({type}) => type == 'page')
    this.totalSteps = this.pages.length

    this.responses = await this.controller.getTempData("feedback", [] )

    this.pageObserver = this.route.queryParams.subscribe((params: Params) => {
      if (params.page && params.page != this.page) {
        this.page = parseInt(params.page);
        this.loadPage()
      }
    })
  }

  handleValueChange(value){
    this.displayRequired = false

    this.value = value
    this.addResponse(this.question,value)

  }

  addResponse(question, answer){
    this.responses = this.responses.filter( ({question: q}) => q != question)
    this.responses.push( {question,answer} )
  }

  hasTrueValue( properties, key ){
    return properties && (properties[key] == "true" || properties[key] == true)
  }
  loadPage(){

    this.pageComponent = this.pages[this.page]

    this.requiredText = DEFAULT_REQUIRED_TEXT

    this.elements = this.pages[this.page].elements

    this.textElements = this.elements.filter(({type}) => ['header','p'].includes(type))
    this.otherElements = this.elements.filter(({type}) => !['header','p'].includes(type))

    this.hidePageNumbers = this.hasTrueValue(this.pages[this.page].properties, "hidePageNumbers")

    const question = this.elements.find(({type}) => type == 'header')
    this.question = question.value
    this.optional = this.hasTrueValue( question.properties, 'optional')


    if( question.properties && question.properties.requiredText ){
      this.requiredText = question.properties.requiredText
    }

    if( question.properties && question.properties.saveToUser ){
      this.saveToUser = question.properties.saveToUser
    }

    const response = this.responses.find(({question}) => question == this.question)
    this.value =  response ? response.answer : null

    window.setTimeout( () => {
      if( this.textEntry ){
        this.textEntry.nativeElement.focus()
      }
    },0)

    const answers = this.elements.find( ({type}) => type == 'answers')
    this.dropdownOptions = answers ? answers.elements.map(({value}) => value) : []

    const subComponents = this.pages[this.page].subComponents
    const subComponent = subComponents ? subComponents[0] : null

    if( subComponent && subComponent.type == 'prefill' ){
      subComponent.elements.filter(({type}) => type == 'question').forEach( ({value, properties}) => {
        this.addResponse(value,properties.answer)
      })
    }
  }

  async onNext(){

    this.controller.setErrorMessage("")

    if( !this.value && !this.optional ){
      this.displayRequired = true
      return
    }

    if( this.saveToUser ){
      try{
        const saveToUserResponse : any = await this.http.postAsync('user/saveToUser', {key: this.saveToUser, value: this.value})
        if( !saveToUserResponse.success ){
          throw "Failed"
        }
      }catch( e ){
        // failed, try again.
        this.controller.setErrorMessage("Error saving your progress, please try again.")
        return
      }

    }
    this.controller.storeTempData("feedback", this.responses)
    await this.controller.next()
  }

  async onPrev(){
    await this.controller.back()
  }

  ngOnDestroy(): void {
    this.pageObserver.unsubscribe()
  }

  getPageNumber(): number{
    return this.page + 1
  }

  getNextClass(){
    return {btn:true, active: !!this.value || this.optional, 'btn-outline-primary': true, 'btn-outline': true}
  }

}
